import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LiveClassList } from "@app/shared/models/live-class";
import { MockTestList } from "@app/shared/models/mock-test-list";
import { PackageList } from "@app/shared/models/package";
import { PractiseList } from "@app/shared/models/practise";
import { IndividualMockList, PredictionList } from "@app/shared/models/prediction";
import { YoutubeLinkList } from "@app/shared/models/promotion";
import { PractiseQuestionsList, QuestionsList } from "@app/shared/models/question-list";
import { StudyPlanList } from "@app/shared/models/study-plan";
import { TableFilter } from "@app/shared/models/table-filter";
import { VocabList } from "@app/shared/models/vocab";
import { environment } from "@environments/environment";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})


export class TableListService {
  private baseUrl = environment.apiUrl + "/api/v1/";

  constructor(private http: HttpClient) {

  }

  getMockTestList(filter: TableFilter) {
    let url: string;
    if (filter.search) url = this.baseUrl + "mock-test?search=" + filter.search;
    else

      url =
        this.baseUrl +
        "mock-test?page=" +
        filter.page +
        "&limit=" +
        filter.limit +
        "&sortColumn=" +
        filter.sortColumn +
        "&sortDirection=" +
        filter.sortDirection;

    return this.http.get<MockTestList>(url).pipe(map((obj) => obj));
  }

  getQuestionList(filter: TableFilter, module: any) {
    let url: string;
    if (filter.search) url = this.baseUrl + `${module.moduleName.toLowerCase()}/practises/${module.questionType}?search=` + filter.search;
    else

      url =
        this.baseUrl +
        `${module.moduleName.toLowerCase()}/practises/${module.questionType}?page=` +
        filter.page +
        "&limit=" +
        filter.limit +
        "&sortColumn=" +
        filter.sortColumn +
        "&sortDirection=" +
        filter.sortDirection;

    return this.http.get<PractiseQuestionsList>(url).pipe(map((obj) => obj));
  }

  getManageQuestionList(filter: TableFilter, module: any) {
    let url: string;
    if (filter.search) url = this.baseUrl + `${module.moduleType.toLowerCase()}/${module.questionType}/manage?search=` + filter.search;
    else

      url =
        this.baseUrl +
        `${module.moduleType.toLowerCase()}/${module.questionType}/manage?page=` +
        filter.page +
        "&limit=" +
        filter.limit +
        "&sortColumn=" +
        filter.sortColumn +
        "&sortDirection=" +
        filter.sortDirection;

    return this.http.get<QuestionsList>(url).pipe(map((obj) => obj));
  }

  getPredictionList(filter: TableFilter, module: any, type: string) {
    let url: string;
    if (filter.search) url = this.baseUrl + `${module.toLowerCase()}/${type}/manages?search=` + filter.search;
    else

      url =
        this.baseUrl +
        `${module.toLowerCase()}/${type}/manages?page=` +
        filter.page +
        "&limit=" +
        filter.limit +
        "&sortColumn=" +
        filter.sortColumn +
        "&sortDirection=" +
        filter.sortDirection;

    return this.http.get<PredictionList>(url).pipe(map((obj) => obj));
  }

  getLiveClassList(filter: TableFilter) {
    let url: string;
    if (filter.search) url = this.baseUrl + `liveclass/manage?search=` + filter.search;
    else

      url =
        this.baseUrl +
        `liveclass/manage?page=` +
        filter.page +
        "&limit=" +
        filter.limit +
        "&sortColumn=" +
        filter.sortColumn +
        "&sortDirection=" +
        filter.sortDirection;

    return this.http.get<LiveClassList>(url).pipe(map((obj) => obj));
  }
  getMockList(filter: TableFilter, module: any) {
    let url: string;
    if (filter.search) url = this.baseUrl + `${module.toLowerCase()}/mock-test/manages?search=` + filter.search;
    else

      url =
        this.baseUrl +
        `${module.toLowerCase()}/mock-test/manages?page=` +
        filter.page +
        "&limit=" +
        filter.limit +
        "&sortColumn=" +
        filter.sortColumn +
        "&sortDirection=" +
        filter.sortDirection;

    return this.http.get<IndividualMockList>(url).pipe(map((obj) => obj));
  }

  getStudyPlanList(filter: TableFilter, module: any) {
    let url: string;
    if (filter.search) url = this.baseUrl + `${module.toLowerCase()}/study-plan/manages?search=` + filter.search;
    else

      url =
        this.baseUrl +
        `${module.toLowerCase()}/study-plan/manages?page=` +
        filter.page +
        "&limit=" +
        filter.limit +
        "&sortColumn=" +
        filter.sortColumn +
        "&sortDirection=" +
        filter.sortDirection;

    return this.http.get<StudyPlanList>(url).pipe(map((obj) => obj));
  }

  getOtherList(filter: TableFilter, module: any, type: string) {
    let url: string;
    if (filter.search) url = this.baseUrl + `${module.toLowerCase()}/${type}?search=` + filter.search;
    else

      url =
        this.baseUrl +
        `${module.toLowerCase()}/${type}?page=` +
        filter.page +
        "&limit=" +
        filter.limit +
        "&sortColumn=" +
        filter.sortColumn +
        "&sortDirection=" +
        filter.sortDirection;

    return this.http.get<PredictionList>(url).pipe(map((obj) => obj));
  }

  getPractiseList(filter: TableFilter, module: string) {
    let url: string;
    if (filter.search) url = this.baseUrl + `${module.toLowerCase()}/practise?search=` + filter.search;
    else

      url =
        this.baseUrl +
        `${module.toLowerCase()}/practise?page=` +
        filter.page +
        "&limit=" +
        filter.limit +
        "&sortColumn=" +
        filter.sortColumn +
        "&sortDirection=" +
        filter.sortDirection;

    return this.http.get<PractiseList>(url).pipe(map((obj) => obj));
  }

  getManagePackages(filter: TableFilter) {
    let url: string;
    if (filter.search) url = this.baseUrl + `ai/store/packages?search=` + filter.search;
    else

      url =
        this.baseUrl +
        `ai/store/packages?page=` +
        filter.page +
        "&limit=" +
        filter.limit +
        "&sortColumn=" +
        filter.sortColumn +
        "&sortDirection=" +
        filter.sortDirection;

    return this.http.get<PackageList>(url).pipe(map((obj) => obj));
  }

  getUserList(filter: TableFilter) {
    let url: string;
    if (filter.search) url = this.baseUrl + `users?search=` + filter.search;
    else

      url =
        this.baseUrl +
        `users?page=` +
        filter.page +
        "&limit=" +
        filter.limit +
        "&sortColumn=" +
        filter.sortColumn +
        "&sortDirection=" +
        filter.sortDirection;

    return this.http.get<StudyPlanList>(url).pipe(map((obj) => obj));
  }

  getGuestList(filter: TableFilter) {
    let url: string;
    if (filter.search) url = this.baseUrl + "users?isGuest=true&search=" + filter.search;
    else

      url =
        this.baseUrl +
        "users?isGuest=true&page=" +
        filter.page +
        "&limit=" +
        filter.limit +
        "&sortColumn=" +
        filter.sortColumn +
        "&sortDirection=" +
        filter.sortDirection;

    return this.http.get<MockTestList>(url).pipe(map((obj) => obj));
  }

  getVocabList(filter: TableFilter, qcode: string) {
    let url: string;
    if (filter.search) url = this.baseUrl + "vocab/" + qcode + "/manage?search=" + filter.search;
    else

      url =
        this.baseUrl +
        "vocab/" + qcode + "/manage?page=" +
        filter.page +
        "&limit=" +
        filter.limit +
        "&sortColumn=" +
        filter.sortColumn +
        "&sortDirection=" +
        filter.sortDirection;

    return this.http.get<VocabList>(url).pipe(map((obj) => obj));
  }

  getYoutubeLink(filter: TableFilter) {
    let url: string;
    if (filter.search) url = this.baseUrl + "dashboard/youtubelink?search=" + filter.search;
    else

      url =
        this.baseUrl +
        "dashboard/youtubelink?page=" +
        filter.page +
        "&limit=" +
        filter.limit +
        "&sortColumn=" +
        filter.sortColumn +
        "&sortDirection=" +
        filter.sortDirection;

    return this.http.get<YoutubeLinkList>(url).pipe(map((obj) => obj));
  }
  getGrammarList(filter: TableFilter) {
    let url: string;
    if (filter.search) url = this.baseUrl + "grammar/manage?search=" + filter.search;
    else

      url =
        this.baseUrl +
        "grammar/manage?page=" +
        filter.page +
        "&limit=" +
        filter.limit +
        "&sortColumn=" +
        filter.sortColumn +
        "&sortDirection=" +
        filter.sortDirection;

    return this.http.get<VocabList>(url).pipe(map((obj) => obj));
  }

  /************************************************
*************  Delete ************************
*************************************************/

  onDeleteQuestion(id: string, moduleName: string, questionCode: string) {
    return this.http
      .delete<any>(`${this.baseUrl}${moduleName}/${questionCode}/${id}/delete`)
      .pipe(map((obj) => obj || {}));
  }

  onDeleteOtherModule(id: string, name: string, routeName: string) {
    return this.http
      .delete<any>(`${this.baseUrl}${name}/${routeName}/${id}`)
      .pipe(map((obj) => obj || {}));
  }

  onDeleteMock(id: string) {
    return this.http
      .delete<any>(`${this.baseUrl}mock-test/${id}`)
      .pipe(map((obj) => obj || {}));
  }

  onDeletePackage(id: string, type: string) {
    return this.http
      .delete<any>(`${this.baseUrl}ai/store/packages/${id}/${type}`)
      .pipe(map((obj) => obj || {}));
  }

  onDeleteUser(id: string) {
    return this.http
      .delete<any>(`${this.baseUrl}users/${id}`)
      .pipe(map((obj) => obj || {}));
  }

  onDeleteVocab(id: string, qcode: string) {
    return this.http
      .delete<any>(`${this.baseUrl}vocab/${qcode}/${id}/delete`)
      .pipe(map((obj) => obj || {}));
  }

  onDeleteGrammar(id: string) {
    return this.http
      .delete<any>(`${this.baseUrl}grammar/${id}/delete`)
      .pipe(map((obj) => obj || {}));
  }
  
  onDeleteLiveClass(id: string) {
    return this.http
      .delete<any>(`${this.baseUrl}liveclass/${id}/delete`)
      .pipe(map((obj) => obj || {}));
  }

  onDeleteYoutube(id: string) {
    return this.http
      .delete<any>(`${this.baseUrl}dashboard/youtubelink/${id}`)
      .pipe(map((obj) => obj || {}));
  }


  /************************************************
  *************  Other Table Event ************************
  *************************************************/

  checkClass(id, status) {
    return this.http.get<any>(this.baseUrl + "mock-test/" + id + "/" + status);
  }

  shareMockEvaluate(data) {
    return this.http.post<any>(this.baseUrl + "share/mock-test", data).pipe(map((obj) => obj || {}));
  }

  onStartClassByPrediction(id, data, moduleName) {
    const url = this.baseUrl + `${moduleName.toLowerCase()}/prediction/${id}/start-class`;
    return this.http.put<any>(url, data);
  }

  onReadingPractise(questionCode, data) {
    const url = this.baseUrl + `reading/set-practice-question?type=` + questionCode;
    return this.http.put<any>(url, data);
  }

  onReadingSelectedAll(questionCode, data) {
    const url = this.baseUrl + `reading/set-practice-question?type=` + questionCode +`&selectAll=true`;
    return this.http.put<any>(url, data);
  }


  deactiveUser(id, data) {
    return this.http.put<any>(this.baseUrl + "users/" + id + "/activate-deactivate", data).pipe(map((obj) => obj || {}));
  }

}